module.exports = __webpack_public_path__ + "34bc775d/img/delete-icon.eb7de062.svg";